import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@omnienv/omnicms/devcms/environment";
import { ApiResult } from "@omnilnp/models/api-result.model";
import { TempLibModel } from "@omnilnp/models/temp-lib.model";
import { Observable } from "rxjs";


@Injectable({
    providedIn: 'root'
}) 
export class TempLibService {
    constructor(
        private httpClient: HttpClient
    ) {

    }

    public saveTempLib(tempLib: TempLibModel): Observable<ApiResult<boolean>> {
        return this.httpClient.put<ApiResult<boolean>>(environment.apiurl + "temp-lib-member", tempLib);
    }

}